import FolderCard from "@/features/shared/components/FolderCard"
import { useNavigate } from "react-router-dom"
import { handleDate } from "../../../utils/Functions"
import { usePlansStore } from "../../../utils/stores/usePlansStore"

const MealPlanHistory = () => {
    const { plans } = usePlansStore()
    const mealPlans = plans.mealPlans
    const navigate = useNavigate()

    return (
        <div className="w-full h-full flex flex-col space-y-[20px] max-w-[1068px]">
            {/* <div className="mt-[10px] space-y-[10px]">
                <BackButton
                    text="Torna a Meal Plan"
                    onClick={() => navigate("/health-plan/meal-plan")}
                />
                <div className="font-bold text-[25px] leading-[33px]">
                    Meal Plan passati
                </div>
            </div> */}
            {
                            mealPlans && mealPlans.map((plan, index) => {
                                if (index !== 0) {
                                    const currentDate = handleDate(plan.created_at, "dd.MM.yyyy");
                                    const prevDate = handleDate(mealPlans[index - 1].created_at, "dd.MM.yyyy");
                                    const spanDate = `${currentDate} <> ${prevDate}`
            
                                    return (
                                        // <div
                                        //     key={plan.id}
                                        //     className="w-full h-[111px] rounded-[5px] flex items-center justify-center self-center flex-shrink-0 shadow-platform cursor-pointer p-[20px]"
                                        //     onClick={() => navigate(`/health-plan/old-meal-plan?id=${plan.id}&span-date=${spanDate}`)}
                                        // >
                                        //     <div className="w-full">
                                        //         <div className="font-medium text-[14px] leading-[33px]">
                                        //             {spanDate}
                                        //         </div>
                                        //     </div>
                                        // </div>
                                        <FolderCard
                                        onClick={() => navigate(`/old-meal-plan?id=${plan.id}&span-date=${spanDate}`)}
                                        title={spanDate}
                                        isTitle={false}
                                        />
                                    );
                                }
                            })
                        }
        </div>
    )
}

export default MealPlanHistory
